import { FormControl, Grid } from '@mui/material'
import { BrandAutocomplete, LineAutocomplete } from '../../../../../shared/components/inputs'
import CustomTextField from '@/contexts/shared/components/inputs/CustomTextField'
import { ISeminar } from '../../../models/Seminars'
interface BasicFormProps {
  seminarState: ISeminar
  handleInputChange: (inputName: string, value: any) => void
}

export const BasicForm = ({ seminarState, handleInputChange }: BasicFormProps) => {
  const { brand, line, title } = seminarState

  return (
    <Grid container alignItems="flex-start" justifyContent="space-between" spacing={2}>
      <Grid item xs={12} sm={6} md={brand != null ? 6 : 8}>
        <CustomTextField inputName="title" value={title} handleInputChange={handleInputChange} required />
      </Grid>
      <Grid item xs={12} sm={brand != null ? 6 : 12} md={brand != null ? 3 : 4}>
        <FormControl fullWidth variant="filled">
          <BrandAutocomplete value={brand} handleInputChange={handleInputChange} />
        </FormControl>
      </Grid>
      {brand !== null && (
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth variant="filled">
            <LineAutocomplete value={line} brand={brand} handleInputChange={handleInputChange} />
          </FormControl>
        </Grid>
      )}
    </Grid>
  )
}
